import { EvaluationType } from "../schemas/types";

export const availableEvaluationTypes: EvaluationType[] = [
    { label: "Desempenho - Pontuação de 0 a 5", value: "aae78f8a-bf13-11f0-a8bc-ad124a4cc8fb", allowWeigth: true, allowMultSection: true, scale: [0,1,2,3,4,5] },
    { label: "Desempenho - Pontuação de 1 a 5", value: "bae78f8a-bf13-11f0-a8bc-ad124a4cc8fb", allowWeigth: true, allowMultSection: true, scale: [1,2,3,4,5] },
    { label: "Conformidade especial - Sim ou Não", value: "cae78f8a-bf13-11f0-a8bc-ad124a4cc8fb", allowWeigth: false, allowMultSection: false, scale: [0,1] },
];
